import { initialsOf } from '@/entities/session/helpers/initials-of';
import { useSession } from '@/entities/session/hooks/use-session';
import { Avatar } from '@/shared/ui/avatar/avatar';
import { AvatarFallback } from '@/shared/ui/avatar/avatar-fallback';

/** Who is signed in: initials, full name and email (the username until the account has one). */
export function AccountSummary() {
  const session = useSession();
  if (!session) return null;
  const { display_name: name, email_address: email, username } = session.user;
  return (
    <div className="flex min-w-0 items-center gap-2.5 p-1.5 group-data-[collapsible=icon]:p-0">
      <Avatar className="size-8 shrink-0 rounded-lg">
        <AvatarFallback className="rounded-lg bg-primary/12 text-xs font-semibold text-primary">
          {initialsOf(name)}
        </AvatarFallback>
      </Avatar>
      <span className="flex min-w-0 flex-col leading-tight group-data-[collapsible=icon]:hidden">
        <span className="truncate text-sm font-medium">{name}</span>
        <span className="truncate text-xs text-muted-foreground">{email || `@${username}`}</span>
      </span>
    </div>
  );
}
